module.exports = new __parcel__URL__("twitter.32a44c08.svg").toString();